import React__default, { useState, useEffect } from 'react';
import { useIsClient } from '@grandvisionhq/lib-utils-react';
import TabLink from './TabLink.js';
import Tabs from './Tabs.js';

const ContentTabs = ({ links  })=>{
    const [activeTabIndex, setActiveTabIndex] = useState(-1);
    const isClient = useIsClient();
    useEffect(()=>{
        if (isClient && links && links.length) {
            const path = window.location.pathname;
            const tabIndex = links.findIndex(({ url  })=>url === path
            );
            setActiveTabIndex(tabIndex);
        }
    }, [
        isClient,
        links
    ]);
    return links && links.length ? /*#__PURE__*/ React__default.createElement(Tabs, {
        activeTabIndex: activeTabIndex
    }, links.map(({ label , url , openInNewWindow  })=>label && url && /*#__PURE__*/ React__default.createElement(TabLink, {
            key: url,
            url: url,
            label: label,
            openInNewWindow: openInNewWindow
        })
    )) : null;
};
var ContentTabs$1 = ContentTabs;

export { ContentTabs$1 as default };
//# sourceMappingURL=ContentTabs.js.map
